// 中文能力
import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';

import classNames from 'classnames';
import { PC } from '@wukong/haomao';
import Title from '../Title';
import { MyContext } from '../../../../config/context-manager';
import styles from './style.module.scss';

const ChineseAbility = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);
  const abilityData = [
    {
      title: t('中文能力-悟空教育-班型设置-标题'),
      main: t('中文能力-悟空教育-班型设置-内容'),
      sub: t('中文能力-其他平台-班型设置-内容'),
      other: t('中文能力-传统教育-班型设置-内容'),
    },
    {
      title: t('中文能力-悟空教育-课程时长-标题'),
      main: t('中文能力-悟空教育-课程时长-内容'),
      sub: t('中文能力-其他平台-课程时长-内容'),
      other: t('中文能力-传统教育-课程时长-内容'),
    },
    {
      title: t('中文能力-悟空教育-课程安排-标题'),
      main: t('中文能力-悟空教育-课程安排-内容'),
      sub: t('中文能力-其他平台-课程安排-内容'),
      other: t('中文能力-传统教育-课程安排-内容'),
    },
    {
      title: t('中文能力-悟空教育-教育师资-标题'),
      main: t('中文能力-悟空教育-教育师资-内容'),
      sub: t('中文能力-其他平台-教育师资-内容'),
      other: t('中文能力-传统教育-教育师资-内容'),
    },
    {
      title: t('中文能力-悟空教育-课程体系-标题'),
      main: t('中文能力-悟空教育-课程体系-内容'),
      sub: t('中文能力-其他平台-课程体系-内容'),
      other: t('中文能力-传统教育-课程体系-内容'),
    },
    {
      title: t('中文能力-悟空教育-教材-标题'),
      main: t('中文能力-悟空教育-教材-内容'),
      sub: t('中文能力-其他平台-教材-内容'),
      other: t('中文能力-传统教育-教材-内容'),
    },
    {
      title: t('中文能力-悟空教育-多媒体教学-标题'),
      main: t('中文能力-悟空教育-多媒体教学-内容'),
      sub: t('中文能力-其他平台-多媒体教学-内容'),
      other: t('中文能力-传统教育-多媒体教学-内容'),
    },
    {
      title: t('中文能力-悟空教育-趣味课堂-标题'),
      main: t('中文能力-悟空教育-趣味课堂-内容'),
      sub: t('中文能力-其他平台-趣味课堂-内容'),
      other: t('中文能力-传统教育-趣味课堂-内容'),
    },
    {
      title: t('中文能力-悟空教育-课后作业-标题'),
      main: t('中文能力-悟空教育-课后作业-内容'),
      sub: t('中文能力-其他平台-课后作业-内容'),
      other: t('中文能力-传统教育-课后作业-内容'),
    },
    {
      title: t('中文能力-悟空教育-教学进度-标题'),
      main: t('中文能力-悟空教育-教学进度-内容'),
      sub: t('中文能力-其他平台-教学进度-内容'),
      other: t('中文能力-传统教育-教学进度-内容'),
    },
    {
      title: t('中文能力-悟空教育-服务体验-标题'),
      main: t('中文能力-悟空教育-服务体验-内容'),
      sub: t('中文能力-其他平台-服务体验-内容'),
      other: t('中文能力-传统教育-服务体验-内容'),
    },
  ];

  return (
    <section
      className={classNames(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <Title>{t('中文能力-标题')} </Title>
          <div className={styles.flowContainer}>
            <div className={styles.abilityLeftContainer}>
              <div className={classNames(styles.abilityRow, styles.bgColorWhite)}>
                <div className={classNames(styles.abilityTitle, styles.abilityTitleTriangle)}>
                  {t('中文能力-悟空教育-标题')}
                </div>
              </div>
              {abilityData.map((item, index) => {
                return (
                  <div
                    key={item.title}
                    className={classNames(styles.abilityRow, styles.abilityTitleFirstRadius, {
                      [styles.borderTopLeft]: index === 0,
                    })}
                  >
                    <div
                      className={classNames(styles.abilityLabel, {
                        [styles.abilityLabelBorder]: index < abilityData.length - 1,
                        [styles.borderTopLeft]: index === 0,
                      })}
                    >
                      {item.title}
                    </div>
                    <div
                      className={classNames(styles.abilityValue, {
                        [styles.abilityValueBorder]: index < abilityData.length - 1,
                        [styles.abilityValueLastRadius]: index === abilityData.length - 1,
                      })}
                    >
                      <span>{item.main}</span>
                    </div>
                  </div>
                );
              })}
              <div className={styles.abilityFooterRow}> </div>
            </div>
            <div className={styles.splitBox}> </div>
            <div className={styles.otherPlatContainer}>
              <div className={styles.otherPlatBox}>
                <div className={styles.otherPlatTitleRow}>{t('中文能力-其他平台-标题')}</div>
                {abilityData.map((item, index) => {
                  return (
                    <div
                      key={`sub-${item.title}`}
                      className={classNames(styles.otherPlatRow, {
                        [styles.splitLine]: index < abilityData.length - 1,
                      })}
                    >
                      {item.sub}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.offlinePlatContainer}>
              <div className={styles.offlinePlatBox}>
                <div className={styles.offlinePlatTitleRow}>{t('中文能力-传统教育-标题')}</div>
                {abilityData.map((item, index) => {
                  return (
                    <div
                      key={`other-${item.title}`}
                      className={classNames(styles.offlinePlatRow, {
                        [styles.splitLine]: index < abilityData.length - 1,
                      })}
                    >
                      {item.other}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </PC>
    </section>
  );
};

export default ChineseAbility;
